import React from 'react';

/**
 * Rend un texte dont certains fragments sont marqués `**ainsi**`.
 *
 * ## Pourquoi ce composant existe
 *
 * Les constats du diagnostic mettent en valeur les mots-clés quand ils sont noyés dans une
 * phrase — un mot-clé en ciblage large s'écrit nu, sans crochets ni guillemets pour le délimiter.
 * Le serveur balise ces fragments avec `**`, à la façon de Markdown.
 *
 * ⚠️ **Pas de `dangerouslySetInnerHTML`.** Ces libellés contiennent des noms de campagnes et des
 * mots-clés venus de l'API d'un annonceur ; y interpréter du HTML ouvrirait une injection pour
 * un simple effet de style. Le texte est découpé et rendu en éléments React, qui échappent tout
 * ce qu'ils reçoivent.
 *
 * ## Ce qu'il ne fait pas
 *
 * Il ne rend pas Markdown : ni liens, ni italique, ni listes. Un seul marqueur, délibérément.
 * Les constats ne sont pas un format de document, et accepter davantage obligerait à se
 * demander ce qu'il advient d'un nom de campagne contenant un tiret bas ou un crochet.
 *
 * ⚠️ Les retours à la ligne sont conservés par le CSS (`white-space: pre-line`) des conteneurs
 * qui l'accueillent — plusieurs constats énumèrent une valeur par ligne.
 */
const TexteAccentue = ({ texte }) => {
  if (!texte) return null;

  const fragments = String(texte).split('**');

  // Sans marqueur, ou avec un marqueur non refermé : on rend le texte tel quel plutôt que de
  // deviner. Un `**` orphelin reste visible, ce qui se corrige — là où le masquer cacherait
  // l'erreur de celui qui a composé le libellé.
  if (fragments.length < 3) return <>{texte}</>;

  return (
    <>
      {fragments.map((fragment, rang) => (
        // Les fragments de rang impair sont ceux qu'encadraient les marqueurs.
        rang % 2 === 1
          ? <strong key={rang}>{fragment}</strong>
          : <React.Fragment key={rang}>{fragment}</React.Fragment>
      ))}
    </>
  );
};

export default TexteAccentue;
